(function() {
	// eslint-disable-next-line no-undef
	angular.module('meanApp').factory('recipesManager', recipesManager);

	recipesManager.$inject = [ 'Recipe', 'modelManager', 'httpAuth', '$http', '$q', 'currentUser' ];
	function recipesManager(Recipe, modelManager, httpAuth, $http, $q, currentUser) {
		// eslint-disable-next-line no-undef
		return angular.extend(
			{
				executeCleverAlgo: function() {
					return httpAuth.get('/api/recipes/cleveralgo');
				},

				getAllRecipesFromUser: function(id, pageNumber) {
					var deferred = $q.defer(),
						scope = this;
					//do we want that to be authenticated ??
					httpAuth
						.get('/api/users/' + id + '/recipes/page/' + pageNumber)
						.success(function(recipesArray) {
							var array = [];
							recipesArray.docs.forEach(function(itemArray) {
								var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
								array.push(instance);
							});

							deferred.resolve({
								recipes: array,
								nbPage: recipesArray.totalPages //remove 1 because starts at 1 for this API for bookmarks and likes pageindex starts
							});
						})
						.error(function(err) {
							deferred.reject(err);
						});

					return deferred.promise;
				},

				getAllRecipesLikedFromUser: function(id, pageNumber) {
					var deferred = $q.defer(),
						scope = this;
					//do we want that to be authenticated ??
					httpAuth
						.get('/api/users/' + id + '/recipes/likes/page/' + pageNumber)
						.success(function(recipesArray) {
							var array = [];
							recipesArray.docs.forEach(function(itemArray) {
								var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
								array.push(instance);
							});

							deferred.resolve({
								recipes: array,
								nbPage: recipesArray.totalPages
							});
						})
						.error(function(err) {
							deferred.reject(err);
						});

					return deferred.promise;
				},

				getAllRecipesBookmarkedFromUser: function(id, pageNumber) {
					var deferred = $q.defer(),
						scope = this;
					//do we want that to be authenticated ??
					httpAuth
						.get('/api/users/' + id + '/recipes/bookmarks/page/' + pageNumber)
						.success(function(recipesArray) {
							var array = [];
							recipesArray.docs.forEach(function(itemArray) {
								var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
								array.push(instance);
							});

							deferred.resolve({
								recipes: array,
								nbPage: recipesArray.totalPages
							});
						})
						.error(function(err) {
							deferred.reject(err);
						});

					return deferred.promise;
				},

				_cachedRecipes: [],

				//if connected call the advanced search
				//otherwise call the regular search
				searchRecipesAdvanced: function(tags, pageNumber) {
					var deferred = $q.defer(),
						scope = this;

					currentUser.get().then(
						function(userModel) {
							if (userModel._id) {
								//user connected
								//needs authenticate for currentuser //TODO implement the API
								httpAuth
									.get('/api/recipes/user/page/' + parseInt(pageNumber) + '?tags=' + tags.join(','))
									.success(function(recipesArray) {
										var array = [];
										recipesArray.docs.forEach(function(itemArray) {
											var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
											array.push(instance);
										});
										recipesArray.docs = array;

										deferred.resolve(recipesArray);
									})
									.error(function(err) {
										deferred.reject(err);
									});
							} else {
								//return a paginated SEARCH
								this.searchRecipes(tags, pageNumber).then(deferred.resolve, deferred.reject); //no user connected
							}
						}.bind(this)
					);

					return deferred.promise;
				},

				//this API can be used for tags as well as the textual search
				searchRecipes: function(tags, pageNumber) {
					var deferred = $q.defer(),
						that = this;

					if (typeof pageNumber === 'undefined') {
						$http
							.get('/api/recipes?tags=' + tags.join(','))
							.success(function(count) {
								deferred.resolve(count);
							})
							.error(function(err) {
								deferred.reject(err);
							});
					} else {
						//perform a paginated recipes call
						$http.get('/api/recipes/page/' + parseInt(pageNumber) + '?tags=' + tags.join(','))
							.success(function(recipesArray) {
								var array = [];
								recipesArray.docs.forEach(function(itemArray) {
									var instance = that._retrieveInstance(itemArray['slug'], itemArray);
									array.push(instance);
								});
								recipesArray.docs = array;

								deferred.resolve(recipesArray);
							})
							.error(function(err) {
								deferred.reject(err);
							});
					}

					return deferred.promise;
                },

				getAllRecipesAdmin: function(page, filters) {
					var deferred = $q.defer(),
						scope = this,
						queryString = '',
						QUESTION_MARK = '?',
						EQUAL = '=',
						AMPERSAND = '&';

					if (filters) {
						var filtersArray = Object.keys(filters),
							key;

						for (var i = 0, l = filtersArray.length; i < l; i++) {
							key = filtersArray[i];
							queryString += (i !== 0 ? AMPERSAND : '') + key + EQUAL + filters[key];
						}
						queryString = QUESTION_MARK + queryString;
					}

					httpAuth
						.get('/api/recipes/adminpage/' + page + queryString)
						.success(function(recipesArray) {
							console.log(recipesArray.docs);
							var recipes = [],
								toBeResolved = {};
							recipesArray.docs.forEach(function(recipeData) {
								var recipe = scope._retrieveInstance(recipeData['slug'], recipeData);
								recipes.push(recipe);
							});

							toBeResolved.collection = recipes;
							toBeResolved.pages = recipesArray.totalPages;
							toBeResolved.total = recipesArray.totalDocs;
							deferred.resolve(toBeResolved);
						})
						.error(function(err) {
							deferred.reject(err);
						});
					return deferred.promise;
				}
			},
			modelManager.init(Recipe)
		);
	}
})();
